// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-svg-container[data-v-ddf1b5b4]{position:relative}.banner-svg-container__back[data-v-ddf1b5b4]{position:absolute;z-index:-1;height:100%;width:100%;background:linear-gradient(242.69deg,#6dc1dc 16.13%,#a690fc 30.79%,#fc96bb 56.79%,#ffc397 84.3%);filter:blur(176.5px);transform:matrix(-1,-.01,-.01,1,0,0)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
